import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useTranslation } from 'react-i18next';
import { useRecoilValue } from 'recoil';
import { EmptyIcon } from '@/components/Icons/EmptyIcon';
import { themeSelector } from '@/state/config';
import styles from './EmptyMessage.module.scss';
export const EmptyMessage = () => {
    const { t } = useTranslation();
    const theme = useRecoilValue(themeSelector);
    return (_jsxs("div", { className: styles.container, children: [_jsx(EmptyIcon, { theme: theme }), _jsx("p", { children: t('no_messages') })] }));
};
